/**
 * System/firebase.js — Firebase initialization.
 * Called once at app startup to configure the Firebase SDK for the
 * "nimble-finance" project. Only Firebase Authentication is used.
 */
import { initializeApp } from "firebase/app";

/** Initialize the Firebase app instance with the nimble-finance project config. */
export const initFirebase = () => {
  const firebaseConfig = {
    apiKey: "AIzaSyBT52cXwZhv5HzITi5IKYmD0HdAEUT8kgo",
    authDomain: "nimble-finance.firebaseapp.com",
    projectId: "nimble-finance",
    storageBucket: "nimble-finance.appspot.com",
    messagingSenderId: "1037606335964",
    appId: "1:1037606335964:web:002eafcce053927e138b19"
  };  
  initializeApp(firebaseConfig);
};
